import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router";
import SplashScreen from "src/components/splash-screen";
import { paths } from "src/pages/paths";
import { useAuthContext } from "../hooks";

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

interface Props {
	children: React.ReactNode;
}

export default function AuthGuard({ children }: Props) {
	const { loading } = useAuthContext();
	return loading ? <SplashScreen /> : <Container>{children}</Container>;
}

// ----------------------------------------------------------------------

function Container({ children }: Props) {
	const { user, loading } = useAuthContext();
	const navigate = useNavigate();
	const check = useCallback(() => {
		if (!user && !loading) {
			const searchParams = new URLSearchParams({
				returnTo: window.location.pathname,
			}).toString();

			const href = `${paths.auth.login}?${searchParams}`;

			void navigate(href, { replace: true });
		}
	}, [user, loading, navigate]);

	useEffect(() => {
		check();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	// if (!checked) {
	//   return null;
	// }

	return <>{children}</>;
}
